import { inject } from '@angular/core';
import { type ResolveFn } from '@angular/router';
import { catchError, of } from 'rxjs';

import { OnboardingApiService } from '@shared/services/onboarding-api.service';
import type { InvestmentKnowledgeChoicesResponse } from '@shared/interfaces/opportunity.interface';

export type InvestmentKnowledgeInitData = InvestmentKnowledgeChoicesResponse | null;

export const investmentKnowledgeResolver: ResolveFn<InvestmentKnowledgeInitData> = () => {
  const onboardingApi = inject(OnboardingApiService);
  return onboardingApi.getInvestmentKnowledgeChoices().pipe(catchError(() => of(null)));
};
